import { render } from "./CalculadoraLayout.vue?vue&type=template&id=4d2da1cc&scoped=true"
const script = {}

import "./CalculadoraLayout.vue?vue&type=style&index=0&id=4d2da1cc&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2da1cc"]])

export default __exports__